// extracted by mini-css-extract-plugin
export default {"zoomModal":"Z2-z","image":"_2-z","button":"a3-z","isOverlayShown":"b3-z"};